import React, { useCallback } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import style from "./solution.module.css";

type Preview = {
  id: string;
  num: string;
  title: string;
  subtitle?: string;
  description: string;
  accent?: "green" | "red";
  icon?: React.ReactNode;
};

type Detail = {
  title: string;
  description: string;
  features: string[];
  tags: string[];
};

type SolutionBlock = {
    id: string;
    num: string;
    title: string;
    subtitle: string;
    description: string;
    accent?: "green" | "red";
    details: Detail[];
    icon?: React.ReactNode;
};

const PREVIEWS: Preview[] = [
  {
    id: "concep-ai",
    num: "01",
    title: "X concep AI",
    description: "Text to 3D Design Generation을 통한 혁신적인 설계 자동화 플랫폼",
    icon: (
                                    <svg
                                        width="346"
                                        height="111"
                                        viewBox="0 0 346 111"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className={[
                                            style["logo--about--eyebrow"],
                                            style["logo--about--eyebrow--x-concep"],
                                        ].join(" ")}
                                    >
                                        <g clipPath="url(#clip0_132_12)">
                                            <path
                                                d="M128.36 54.95C128.36 47.72 134.32 43.04 140.96 43.04C145.35 43.04 148.72 45.19 150.92 48.41L145.31 51.92C144.43 50.55 142.58 49.72 141.01 49.72C137.69 49.72 135.74 52.11 135.74 54.94C135.74 57.77 137.69 60.31 141.01 60.31C142.57 60.31 144.43 59.48 145.31 58.11L150.92 61.62C148.72 64.84 145.35 66.99 140.96 66.99C134.32 66.99 128.36 62.16 128.36 54.93V54.95Z"
                                                fill="white"
                                            />
                                            <path
                                                d="M153.6 55.05C153.6 47.82 159.46 43.04 165.95 43.04C172.44 43.04 178.35 47.82 178.35 55.05C178.35 62.28 172.44 67.01 165.95 67.01C159.46 67.01 153.6 62.23 153.6 55.05ZM170.98 55.05C170.98 51.93 168.73 49.73 165.95 49.73C163.17 49.73 160.92 51.93 160.92 55.05C160.92 58.17 163.17 60.32 165.95 60.32C168.73 60.32 170.98 58.17 170.98 55.05Z"
                                                fill="white"
                                            />
                                            <path
                                                d="M205.83 54.1698V66.4198H198.6V54.6098C198.6 51.0998 196.45 49.7298 194.65 49.7298C192.7 49.7298 190.26 50.7598 190.26 54.5598V66.4198H183.03V43.6198H190.26V47.5698C191.14 44.4498 194.7 43.0298 196.8 43.0298C202.85 43.0298 205.83 47.1798 205.83 54.1598V54.1698Z"
                                                fill="white"
                                            />
                                            <path
                                                d="M210.23 54.95C210.23 47.72 216.19 43.04 222.83 43.04C227.22 43.04 230.59 45.19 232.79 48.41L227.18 51.92C226.3 50.55 224.45 49.72 222.88 49.72C219.56 49.72 217.61 52.11 217.61 54.94C217.61 57.77 219.56 60.31 222.88 60.31C224.44 60.31 226.3 59.48 227.18 58.11L232.79 61.62C230.59 64.84 227.22 66.99 222.83 66.99C216.19 66.99 210.23 62.16 210.23 54.93V54.95Z"
                                                fill="white"
                                            />
                                            <path
                                                d="M259.68 57.15H242.98C243.66 59.35 245.57 60.71 248.3 60.71C250.45 60.71 252.64 59.73 254.06 58.37L257.77 63.06C255.52 65.5 251.62 67.01 247.81 67.01C240.58 67.01 235.51 62.03 235.51 55.1C235.51 47.68 241.22 43.04 247.76 43.04C254.3 43.04 259.77 47.63 259.77 54.56C259.77 55.19 259.72 56.02 259.67 57.15H259.68ZM252.6 52.9C252.5 50.65 250.5 49.14 247.91 49.14C245.76 49.14 243.66 50.17 242.93 52.9H252.6Z"
                                                fill="white"
                                            />
                                            <path
                                                d="M289.7 55C289.7 62.37 284.33 67.01 278.62 67.01C276.28 67.01 273.25 66.03 271.59 63.89V77.66H264.36V43.63H271.59V46.07C273.25 43.97 276.28 43.04 278.62 43.04C284.33 43.04 289.7 47.68 289.7 55ZM282.38 55C282.38 52.12 279.94 49.73 277.11 49.73C274.28 49.73 271.84 52.07 271.84 55C271.84 57.93 274.38 60.32 277.11 60.32C279.84 60.32 282.38 57.93 282.38 55Z"
                                                fill="white"
                                            />
                                            <path
                                                d="M326.27 66.4198L323.73 58.6098H311.92L309.43 66.4198H301.23L313.68 32.7798H322.03L334.43 66.4198H326.28H326.27ZM314.01 51.9698H321.58L317.77 40.1098L314.01 51.9698Z"
                                                fill="white"
                                            />
                                            <path d="M337.84 66.4198V32.7798H345.5V66.4198H337.84Z" fill="white" />
                                            <path
                                                d="M95.2596 48.33H62.0596L94.6896 0H127.89L95.2596 48.33Z"
                                                fill="url(#paint0_linear_132_12)"
                                            />
                                            <path
                                                d="M51.4904 88.5602L36.7104 110.46H3.44043L34.8604 63.9302L51.4904 88.5602Z"
                                                fill="url(#paint1_linear_132_12)"
                                            />
                                            <path
                                                d="M74.19 97.3C74.13 97.3 74.06 97.3 74 97.3L12.96 6.9H37.8L59.76 39.43L63.88 33.33L41.37 0H0L4.66 6.9L68.24 101.07C67.84 101.92 67.62 102.87 67.62 103.87C67.62 107.5 70.56 110.44 74.19 110.44C77.82 110.44 80.76 107.5 80.76 103.87C80.76 100.24 77.82 97.3 74.19 97.3Z"
                                                fill="white"
                                            />
                                            <path
                                                d="M127.83 103.56L101.38 64.3802C101.74 63.5702 101.94 62.6702 101.94 61.7302C101.94 58.1002 98.9997 55.1602 95.3697 55.1602C91.7397 55.1602 88.7997 58.1002 88.7997 61.7302C88.7997 65.3602 91.7397 68.3002 95.3697 68.3002C95.5097 68.3002 95.6497 68.3002 95.7896 68.2902L119.6 103.56H94.7597L62.1297 55.2302H53.8896L91.1796 110.46H132.49L127.83 103.56Z"
                                                fill="white"
                                            />
                                        </g>
                                        <defs>
                                            <linearGradient
                                                id="paint0_linear_132_12"
                                                x1="83.1596"
                                                y1="44.63"
                                                x2="109.28"
                                                y2="-0.609999"
                                                gradientUnits="userSpaceOnUse"
                                            >
                                                <stop offset="0.15" stopColor="#05448E" />
                                                <stop offset="1" stopColor="#7FBFE9" />
                                            </linearGradient>
                                            <linearGradient
                                                id="paint1_linear_132_12"
                                                x1="22.9404"
                                                y1="107.35"
                                                x2="44.0304"
                                                y2="70.8302"
                                                gradientUnits="userSpaceOnUse"
                                            >
                                                <stop stopColor="#7FBFE9" />
                                                <stop offset="0.85" stopColor="#05448E" />
                                            </linearGradient>
                                            <clipPath id="clip0_132_12">
                                                <rect width="345.5" height="110.46" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
    ),
  },
  {
    id: "fajob",
    num: "02",
    title: "FAJOB Platform",
    description: "자동화 분야 엔지니어 매칭과 업무관리 통합 솔루션",
    accent: "green",
    icon: (
                                    <svg
                                        width="324"
                                        height="93"
                                        viewBox="0 0 324 93"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className={[style["logo--about--eyebrow"], style["logo--about--eyebrow--fajob"]].join(
                                            " "
                                        )}
                                    >
                                        <g clipPath="url(#clip0_132_3)">
                                            <path
                                                d="M2.05733 72.9564C0.719068 72.7675 0 71.9423 0 70.5702V2.58499C0 1.80949 0.219715 1.19307 0.659146 0.735728C1.08859 0.288326 1.6179 0.0397691 2.22711 0H49.0264C49.8753 0 50.5345 0.248557 50.9739 0.74567C51.4034 1.23284 51.6231 1.87909 51.6231 2.67447V14.7046C51.6231 15.331 51.4034 15.9375 50.9639 16.4942C50.6443 16.9019 50.0451 17.3791 48.9765 17.3791H19.6046V31.7656H41.2066C41.9057 31.7656 42.5049 31.9644 42.9943 32.3521C43.5036 32.7598 43.7633 33.406 43.7633 34.2511V45.8836C43.7633 46.5099 43.5535 47.1065 43.1341 47.6732C42.6947 48.2697 42.0755 48.568 41.3164 48.568H19.6246V70.5106C19.6246 72.1113 18.7257 72.9464 17.0279 72.9464H2.05733V72.9564Z"
                                                fill="#05579E"
                                            />
                                            <path
                                                d="M104.015 75.4122C103.716 75.3426 103.486 75.094 103.226 74.7858C102.697 73.553 101.399 70.0533 100.5 67.6473L99.8808 65.9969C99.3215 64.5353 98.7722 63.0539 98.213 61.5825L98.1031 61.2842H72.6361L72.5263 61.5825C71.967 63.0639 71.4077 64.5353 70.8385 66.0068C70.1993 67.6473 69.5801 69.2877 68.9609 70.9382C68.4815 72.2903 67.5427 72.9664 66.1445 72.9664H51.7232C51.0241 72.9664 50.4349 72.7775 49.9655 72.3997C49.596 72.1014 49.2365 71.5446 49.6359 70.5405L76.1516 2.18737C76.2215 1.8891 76.3413 1.65048 76.5411 1.40193C76.7408 1.15337 76.9805 0.914756 77.2701 0.705969C77.5498 0.497181 77.8594 0.31822 78.1789 0.198913C78.5085 0.0696634 78.8281 0.0100098 79.1377 0.0100098H91.6515C92.2906 0.0100098 92.8399 0.208855 93.2993 0.606546C93.7088 0.964468 94.0184 1.27268 94.2281 1.561L94.2581 1.59083L95.4965 4.40449L119.975 59.077C120.085 59.3355 120.324 59.942 120.354 60.1508C120.464 60.807 120.075 61.1152 120.045 61.145L105.653 74.4776C105.523 74.6069 105.214 74.9151 104.914 75.1636C104.575 75.452 104.245 75.4917 104.015 75.4321V75.4122ZM84.9402 25.3628C84.5806 26.3769 84.2111 27.4407 83.8516 28.5344C83.2124 30.4433 82.5932 32.3721 81.974 34.3208C81.3548 36.2695 80.7256 38.1883 80.0865 40.0873C79.5871 41.5687 79.0878 43.0004 78.5984 44.3525L78.3787 44.959H92.4005L85.3896 24.1101L84.9502 25.3529L84.9402 25.3628Z"
                                                fill="#05579E"
                                            />
                                            <path
                                                d="M134.915 93C133.007 93 131.11 92.7813 129.262 92.3637C127.424 91.9362 125.647 91.2999 123.979 90.4647C122.311 89.6296 120.743 88.5757 119.315 87.3528C117.887 86.1299 116.608 84.6883 115.51 83.0776C115.32 82.7893 115.1 82.4214 114.99 82.1828C114.851 81.8746 114.791 81.3079 115.18 80.9201L125.117 71.6639C125.427 71.3557 125.677 71.0872 125.926 70.9182C126.156 70.7591 126.386 70.6995 126.575 70.6995C126.645 70.6995 126.875 70.7393 127.055 70.8188C127.255 70.9083 127.964 71.5645 128.183 71.7733L129.691 72.9961C130.211 73.4137 130.82 73.8015 131.509 74.1495C132.168 74.4776 132.987 74.6466 133.946 74.6466C134.655 74.6466 135.334 74.5074 136.013 74.229C136.692 73.9506 137.292 73.5827 137.791 73.1254C138.29 72.6681 138.7 72.1312 139.009 71.5048C139.309 70.8884 139.459 70.2322 139.459 69.5362V2.29666C139.459 0.924631 140.248 0.109365 141.686 0H156.097C158.025 0 159.083 1.02405 159.083 2.87332V69.5362C159.083 72.7774 158.424 75.8695 157.126 78.703C155.828 81.5366 154.06 84.042 151.863 86.1597C149.666 88.2675 147.079 89.9577 144.173 91.1706C141.266 92.3836 138.16 93 134.935 93H134.915Z"
                                                fill="#05579E"
                                            />
                                            <path
                                                d="M267.004 72.9564C266.265 72.9564 265.666 72.7575 265.206 72.3598C264.737 71.9522 264.497 71.3358 264.497 70.5205V2.58499C264.497 1.81944 264.717 1.19307 265.146 0.715843C265.586 0.238615 266.205 0 266.994 0H299.452C302.348 0 305.124 0.556767 307.701 1.66036C310.268 2.76395 312.555 4.28512 314.482 6.21392C316.41 8.13278 317.958 10.4096 319.076 12.9846C320.195 15.5597 320.764 18.3733 320.764 21.3262C320.764 23.7819 320.375 26.1084 319.596 28.236C318.907 30.1151 317.948 31.8451 316.749 33.3861L316.5 33.7043L316.789 33.9926C318.907 36.0507 320.624 38.4865 321.903 41.2306C323.281 44.2133 323.99 47.4246 323.99 50.7652C323.99 53.7579 323.401 56.6212 322.252 59.2957C321.104 61.9602 319.526 64.3364 317.568 66.3547C315.611 68.373 313.284 69.9936 310.667 71.1767C308.041 72.3598 305.234 72.9564 302.338 72.9564H267.004ZM284.122 57.8044H296.705C297.724 57.8044 298.683 57.5856 299.542 57.1581C300.411 56.7306 301.19 56.144 301.839 55.4083C302.488 54.6825 303.007 53.8473 303.367 52.9128C303.726 51.9881 303.906 51.0138 303.906 50.0196C303.906 49.0949 303.726 48.1504 303.367 47.2258C303.007 46.2912 302.498 45.4561 301.859 44.7303C301.219 44.0045 300.44 43.398 299.562 42.9407C298.683 42.4833 297.724 42.2546 296.715 42.2546H284.132V57.8143L284.122 57.8044ZM284.122 28.4647H294.119C295.187 28.4647 296.176 28.2957 297.065 27.9775C297.944 27.6594 298.703 27.1921 299.322 26.5956C299.941 25.999 300.43 25.2832 300.79 24.4679C301.15 23.6626 301.329 22.7479 301.329 21.7636C301.329 20.839 301.16 19.974 300.82 19.1786C300.48 18.3833 299.991 17.6674 299.372 17.051C298.753 16.4346 298.004 15.9474 297.135 15.5895C296.266 15.2316 295.307 15.0526 294.278 15.0526H284.142V28.4647H284.122Z"
                                                fill="#05579E"
                                            />
                                            <path
                                                d="M127.615 71.7335C127.645 71.1767 127.215 70.7293 126.566 70.6895C125.987 70.6597 125.518 71.1568 125.518 71.7335C125.518 72.3101 125.987 72.7774 126.566 72.7774C127.145 72.7774 127.585 72.3101 127.615 71.7335Z"
                                                fill="#05579E"
                                            />
                                            <path
                                                d="M115.91 82.7097C116.489 82.7097 116.959 82.2423 116.959 81.6658C116.959 81.0892 116.489 80.6218 115.91 80.6218C115.331 80.6218 114.861 81.0892 114.861 81.6658C114.861 82.2423 115.331 82.7097 115.91 82.7097Z"
                                                fill="#05579E"
                                            />
                                            <path
                                                d="M211.296 1.19312C188.345 1.19312 169.729 19.7156 169.729 42.5728C169.729 56.2534 176.411 68.3532 186.688 75.8894C186.098 71.6043 182.842 68.5421 181.374 62.3082C179.077 52.5847 181.075 37.2537 193.279 33.3265C192.55 35.5536 192.38 37.1742 192.38 39.6399C192.38 52.2268 202.627 62.4375 215.28 62.4375C220.224 62.4375 224.798 60.8766 228.543 58.222C233.167 62.3878 235.424 68.5719 235.424 75.611C235.424 75.8397 235.414 76.0584 235.404 76.2771C245.961 68.7707 252.852 56.4821 252.852 42.5828C252.852 19.7355 234.246 1.20306 211.286 1.20306L211.296 1.19312ZM215.49 55.4381C205.973 55.4381 198.173 48.1803 197.334 38.9141C197.334 38.9141 197.354 38.9141 197.364 38.924L207.231 41.4792C209.238 41.9962 211.286 40.8031 211.815 38.8047C212.334 36.8063 211.136 34.7682 209.128 34.2412C209.128 34.2412 198.542 31.5668 198.183 31.5767C200.58 24.3487 207.421 19.119 215.49 19.119C225.557 19.119 233.727 27.2419 233.727 37.2736C233.727 47.3054 225.567 55.4282 215.49 55.4282V55.4381Z"
                                                fill="url(#paint0_linear_132_3)"
                                            />
                                        </g>
                                        <defs>
                                            <linearGradient
                                                id="paint0_linear_132_3"
                                                x1="211.296"
                                                y1="0.934616"
                                                x2="211.296"
                                                y2="75.7601"
                                                gradientUnits="userSpaceOnUse"
                                            >
                                                <stop stopColor="#00AC94" />
                                                <stop offset="0.9" stopColor="#005BAA" />
                                            </linearGradient>
                                            <clipPath id="clip0_132_3">
                                                <rect width="324" height="93" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
    ),
  },
  {
    id: "total-solution",
    num: "03",
    title: "TOTAL Solution",
    description: "자동화 시스템 개발·설계·제작 TOTAL 솔루션 제공",
    accent: "red",
    icon: (
        <svg width="230" height="60" viewBox="0 0 230 60" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M52.0145 0H17.3373L0 30L17.3373 60H52.0145L69.3518 30L52.0145 0ZM46.8848 54.6341H33.9447C32.8655 54.6341 31.9914 53.761 31.9914 52.6829C31.9914 51.6049 32.8655 50.7317 33.9447 50.7317H46.8848C47.964 50.7317 48.838 51.6049 48.838 52.6829C48.838 53.761 47.964 54.6341 46.8848 54.6341ZM46.8848 47.0732H39.0719C37.9927 47.0732 37.1187 46.2 37.1187 45.122C37.1187 44.0439 37.9927 43.1707 39.0719 43.1707H46.8848C47.964 43.1707 48.838 44.0439 48.838 45.122C48.838 46.2 47.964 47.0732 46.8848 47.0732ZM46.7627 24.3902H33.7005V35.6098H46.8848C47.964 35.6098 48.838 36.4829 48.838 37.561C48.838 38.639 47.964 39.5122 46.8848 39.5122H31.5031C30.424 39.5122 29.5499 38.639 29.5499 37.561C29.5499 37.5415 29.5499 37.5244 29.5524 37.5073C29.5524 37.4902 29.5499 37.4707 29.5499 37.4537V24.3927H22.3474C21.2023 24.3927 20.2721 23.4634 20.2721 22.3195C20.2721 21.1756 21.2023 20.2463 22.3474 20.2463H46.7627C47.9078 20.2463 48.838 21.1756 48.838 22.3195C48.838 23.4634 47.9078 24.3927 46.7627 24.3927V24.3902ZM48.838 30C48.838 31.078 47.964 31.9512 46.8848 31.9512H39.0719C37.9927 31.9512 37.1187 31.078 37.1187 30C37.1187 28.922 37.9927 28.0488 39.0719 28.0488H46.8848C47.964 28.0488 48.838 28.922 48.838 30ZM46.8848 16.8293H39.0719C37.9927 16.8293 37.1187 15.9561 37.1187 14.878C37.1187 13.8 37.9927 12.9268 39.0719 12.9268H46.8848C47.964 12.9268 48.838 13.8 48.838 14.878C48.838 15.9561 47.964 16.8293 46.8848 16.8293ZM46.7627 9.39024H34.0667C32.9217 9.39024 31.9914 8.46098 31.9914 7.31707C31.9914 6.17317 32.9217 5.2439 34.0667 5.2439H46.7627C47.9078 5.2439 48.838 6.17317 48.838 7.31707C48.838 8.46098 47.9078 9.39024 46.7627 9.39024Z" fill="#666666" /> <path d="M82.5312 8.29297V10.732H85.9494V22.4393H88.8792V10.732H92.2974V8.29297H82.5312Z" fill="#666666" /> <path d="M102.551 8.29297V13.6588H97.424V8.29297H94.4941V22.4393H97.424V16.0978H102.551V22.4393H105.481V8.29297H102.551Z" fill="#666666" /> <path d="M117.934 10.732V8.29297H111.098C109.75 8.29297 108.656 9.38565 108.656 10.732H108.668C108.661 10.8125 108.656 10.893 108.656 10.9759V22.4393H117.934V20.0003H111.342V16.0978H117.202V13.6588H111.342V10.732H117.934Z" fill="#666666" /> <path d="M97.0916 33.8268V30H86.3659C84.2491 30 82.5352 31.7122 82.5352 33.8268H82.5547C82.5425 33.9537 82.5352 34.0805 82.5352 34.2098V52.1951H97.0916V48.3683H86.7492V42.2463H95.9441V38.4195H86.7492V33.8268H97.0916Z" fill="#666666" /> <path d="M113.54 30V45.2244L113.484 45.1634L107.468 31.3317C107.116 30.522 106.318 30 105.434 30H102.553C102.013 30 101.576 30.4366 101.576 30.9756V52.1951H105.971V37.8122L111.648 50.8634C111.98 51.6293 112.714 52.1317 113.54 52.1854V52.1951H116.958C117.497 52.1951 117.934 51.7585 117.934 51.2195V30H113.54Z" fill="#666666" /> <path d="M139.907 38.0488H130.629V41.9512H135.512V48.5366H127.455V33.9024H138.686V30H126.479C124.591 30 123.061 31.5293 123.061 33.4146V33.9024H123.09C123.073 34.0634 123.061 34.2244 123.061 34.3902V47.8049C123.061 48.0537 123.087 48.2976 123.126 48.5366H123.061V48.7805C123.061 50.6659 124.591 52.1951 126.479 52.1951H136.489C138.376 52.1951 139.907 50.6659 139.907 48.7805V48.5366H139.841C139.88 48.2976 139.907 48.0537 139.907 47.8049V38.0488Z" fill="#666666" /> <path d="M166.032 30V45.2244L165.976 45.1634L159.96 31.3317C159.608 30.522 158.81 30 157.926 30H155.045C154.505 30 154.068 30.4366 154.068 30.9756V52.1951H158.463V37.8122L164.14 50.8634C164.472 51.6293 165.207 52.1317 166.032 52.1854V52.1951H169.45C169.99 52.1951 170.427 51.7585 170.427 51.2195V30H166.032Z" fill="#666666" /> <path d="M189.871 33.8268V30H179.145C177.028 30 175.314 31.7122 175.314 33.8268H175.334C175.322 33.9537 175.314 34.0805 175.314 34.2098V52.1951H189.871V48.3683H179.529V42.2463H188.723V38.4195H179.529V33.8268H189.871Z" fill="#666666" /> <path d="M208.672 33.8268V30H197.946C195.829 30 194.115 31.7122 194.115 33.8268H194.135C194.123 33.9537 194.115 34.0805 194.115 34.2098V52.1951H208.672V48.3683H198.329V42.2463H207.524V38.4195H198.329V33.8268H208.672Z" fill="#666666" /> <path d="M225.789 43.2073C227.801 42.6049 229.268 40.7415 229.268 38.5366V34.878C229.268 32.1829 227.083 30 224.385 30H213.154V52.1951H217.549V43.4146H221.492L225.606 52.1951H230.001L225.789 43.2073ZM224.996 37.439C224.996 38.7854 223.902 39.878 222.554 39.878H217.549V33.5366H222.554C223.902 33.5366 224.996 34.6293 224.996 35.9756V37.439Z" fill="#666666" /> <path d="M148.941 52.1951V30H144.547V52.1951H148.941Z" fill="#666666" /> </svg>
    ),
  },
];

const SOLUTIONS: SolutionBlock[] = [
  {
    id: "concep-ai",
    num: "01",
    title: "X concep AI",
    subtitle: "Text to 3D Design Generation",
    description:
      "자연어 입력만으로 3D 설계를 자동 생성하는 혁신적 AI 플랫폼. 복잡한 설계 프로세스를 단순화하여 엔지니어링 효율을 극대화합니다.",
    icon: PREVIEWS.find((p) => p.id === "concep-ai")?.icon, // ← 추가
    details: [
      {
        title: "Natural Language Processing",
        description:
          "자연어 처리와 대용량 학습 데이터를 결합해 사용자의 설계 요구를 정확히 해석합니다.",
        features: [
          "한국어 기반 설계 명령어 인식",
          "기술 용어 및 규격 자동 해석",
          "맥락 기반 의도 파악",
          "실시간 대화형 인터페이스",
        ],
        tags: ["LLM", "NLP", "Deep Learning"],
      },
      {
        title: "Generative AI/GAN Integration",
        description:
          "생성형 AI로 2D 이미지부터 3D 모델링까지 자동 생성·최적화합니다.",
        features: [
          "2D 컨셉 이미지 자동 생성",
          "3D 모델링 실시간 생성",
          "설계 변형 및 최적화",
          "STL, STEP 파일 다운로드 출력",
        ],
        tags: ["Generative AI", "GAN", "3D Modeling"],
      },
      {
        title: "Design Validation & Analysis",
        description:
          "AI 기반 설계 검증으로 구조 안정성·제조 가능성을 사전에 분석합니다.",
        features: [
          "구조 해석 및 검증",
          "제조 가능성 평가",
          "재료 최적화 제안",
          "비용 효율 분석",
        ],
        tags: ["FEA", "Simulation", "Optimization"],
      },
    ],
  },
  {
    id: "fajob",
    num: "02",
    title: "FAJOB Platform",
    subtitle: "Engineer Matching & Workflow Management",
    description:
      "자동화 분야 전문 엔지니어와 제조업체를 연결하는 통합 플랫폼. 프로젝트 매칭부터 업무 관리까지 원스톱 제공.",
    accent: "green",
    icon: PREVIEWS.find((p) => p.id === "fajob")?.icon, // ← 추가
    details: [
      {
        title: "Smart Engineer Matching",
        description:
          "AI 기반 매칭으로 프로젝트 요구에 최적화된 엔지니어를 자동 연결합니다.",
        features: [
          "기술 역량 기반 매칭",
          "프로젝트 경험 분석",
          "지역별 엔지니어 배치",
          "실시간 가용성 확인",
        ],
        tags: ["AI Matching", "Mobile App", "Real-time"],
      },
      {
        title: "Integrated Workflow Management",
        description:
          "프로젝트 스케줄 업무를 통합 관리합니다.",
        features: [
          "프로젝트 일정 관리",
          "작업 진행 일수 관리",
          "개인 업무 다이어리",
          "실시간 커뮤니케이션",
        ],
        tags: ["Project Management", "Quality Control", "Collaboration"],
      },
      {
        title: "Supply Chain Integration",
        description:
          "제조 공급망과 연계하여 효율적인 서비스 생태계를 구축합니다.",
        features: [
          "제조업체 네트워크 연결",
          "부품 공급 업체 홍보",
          "블랙리스트 공유",
          "제조 노하우 공유",
        ],
        tags: ["Supply Chain", "Integration", "Automation"],
      },
    ],
  },
  {
    id: "total-solution",
    num: "03",
    title: "TOTAL Solution",
    subtitle: "Complete Automation System Development",
    description:
      "설계→제작→설치→시운전까지 전 과정을 책임지는 종합 엔지니어링 솔루션.",
    accent: "red",
    icon: PREVIEWS.find((p) => p.id === "total-solution")?.icon, // ← 추가
    details: [
      {
        title: "System Design & Engineering",
        description:
          "고객 요구를 바탕으로 최적화된 자동화 시스템을 설계/엔지니어링합니다.",
        features: [
          "현장 맞춤형 시스템 설계",
          "3D 모델링 및 시뮬레이션",
          "제어 시스템 설계",
          "안전 시스템 통합",
        ],
        tags: ["CAD Design", "Simulation", "Control System"],
      },
      {
        title: "Manufacturing & Assembly",
        description:
          "정밀 가공부터 조립까지 고품질 장비를 제작합니다.",
        features: [
          "정밀 기계 가공",
          "전장 시스템 제작",
          "품질 검사 및 테스트",
          "Pre-Assembly 검증",
        ],
        tags: ["Precision Manufacturing", "Quality Assurance", "Testing"],
      },
      {
        title: "Installation & Stabilization",
        description:
          "현장 설치·시운전·안정화까지 완전 가동 상태를 책임집니다.",
        features: [
          "현장 설치 및 배선",
          "시스템 커미셔닝",
          "운영자 교육",
          "성능 최적화 및 안정화",
        ],
        tags: ["Installation", "Commissioning", "Training"],
      },
    ],
  },
];

const SYNERGY = [
  {
    title: "Design to Manufacturing",
    description:
      "Concep AI 설계를 TOTAL Solution으로 직접 제작해 일관성을 보장.",
  },
  {
    title: "Expert Resource Optimization",
    description:
      "FAJOB으로 프로젝트에 최적화된 전문가를 실시간 배치.",
  },
  {
    title: "End-to-End Automation",
    description:
      "설계부터 납품까지 전 과정 자동화로 리드타임을 단축.",
  },
  {
    title: "Quality Assurance",
    description:
      "통합 플랫폼 기반의 일관된 품질관리로 높은 성공률 달성.",
  },
];

export default function Solution() {
  const onPreviewClick = useCallback((id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return (
    <>
        <Header />
            <div className={style["main-content"]}>
                <section className={style["container--front"]}>
                    <div className={style["unit--front--head"]}>
                    <h1 className={style["text--front--head"]}>Solution</h1>
                    <p className={style["text--front--copy"]} style={{ paddingTop: 24, fontSize: 18 }}>
                        Comprehensive Engineering Solutions
                        <br />
                        AI 기반 설계부터 엔지니어 매칭, TOTAL 자동화 솔루션까지 통합 서비스 제공
                    </p>
                    </div>
                </section>

                <section className={style["container--portfolio"]}>
                    <div className={style["unit--content"]}>
                    <h4 className={style["text--content"]}>Three Core Solutions</h4>
                    <p
                        className={style["text--content--copy"]}
                        style={{ width: "min(1000px, 100%)" }}
                    >
                        혁신 기술과 현장 경험이 결합된 3대 핵심 솔루션으로 완전한 엔지니어링 생태계를 구현합니다.
                    </p>

                    {/* Preview Cards (클릭 시 해당 섹션으로 스크롤) */}
                    <div
                        style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                        gap: 20,
                        marginTop: 36,
                        }}
                    >
                        {PREVIEWS.map((p) => (
                        <button
                            key={p.id}
                            onClick={() => onPreviewClick(p.id)}
                            className={style["button--about"]}
                            style={{
                            // 카드 느낌을 위한 래퍼
                            background: "linear-gradient(145deg,#2a2a2a,#1e1e1e)",
                            color: "#fff",
                            borderRadius: 12,
                            border: "1px solid #333",
                            height: "auto",
                            padding: "28px 22px",
                            textAlign: "left",
                            display: "block",
                            cursor: "pointer",
                            minHeight: 140,
                            }}
                        >
                            <div
                                style={{
                                    display: "inline-flex",
                                    alignItems: "left",
                                    justifyContent: "left",
                                    width: 180,
                                    marginBottom: 24,
                                }}
                            >
                                {p.icon}
                            </div>
                            <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 6 }}>
                            {p.title}
                            </div>
                            <div style={{ opacity: 0.85, fontSize: 14 }}>{p.description}</div>
                        </button>
                        ))}
                    </div>
                    </div>
                </section>

                {SOLUTIONS.map((s) => (
                    <section
                    key={s.id}
                    id={s.id}
                    className={style["container--portfolio"]}
                    style={{
                        paddingTop: 80,
                    }}
                    >
                    <div className={style["unit--content"]}>
                        <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "minmax(260px, 1fr) 2fr",
                            gap: 36,
                            alignItems: "start",
                        }}
                        >
                        <div
                            style={{
                            background: "linear-gradient(145deg,#2a2a2a,#1e1e1e)",
                            border: "1px solid #333",
                            borderRadius: 12,
                            padding: 28,
                            position: "sticky",
                            top: 100,
                            }}
                        >
                            <div
                                style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    width: "100%",
                                    marginBottom: 14,
                                }}
                            >
                                {s.icon ? (
                                    <div style={{ width: 180, display: "inline-flex" }}>
                                    {s.icon}
                                    </div>
                                ) : (
                                    <div
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: 56,
                                        height: 56,
                                        borderRadius: 28,
                                        fontWeight: 700,
                                        color: "#fff",
                                        background:
                                        s.accent === "green"
                                            ? "linear-gradient(135deg,#2ecc71,#27ae60)"
                                            : s.accent === "red"
                                            ? "linear-gradient(135deg,#e74c3c,#c0392b)"
                                            : "linear-gradient(135deg,#3498db,#2ecc71)",
                                    }}
                                    >
                                    {s.num}
                                    </div>
                                )}
                            </div>
                            <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 8, color:"#ffffff" }}>
                            {s.title}
                            </h2>
                            <div
                            style={{
                                fontSize: 13,
                                letterSpacing: 1,
                                textTransform: "uppercase",
                                color:
                                s.accent === "green"
                                    ? "#2ecc71"
                                    : s.accent === "red"
                                    ? "#e74c3c"
                                    : "#3498db",
                                marginBottom: 12,
                                fontWeight: 700,
                            }}
                            >
                            {s.subtitle}
                            </div>
                            <p style={{ color: "#cccccc", lineHeight: 1.7 }}>{s.description}</p>
                        </div>

                        <div style={{ display: "grid", gap: 20 }}>
                            {s.details.map((d) => (
                            <article
                                key={d.title}
                                style={{
                                background: "#2a2a2a",
                                border: "1px solid #333",
                                borderRadius: 12,
                                padding: 24,
                                }}
                            >
                                <h3
                                style={{
                                    fontSize: 16,
                                    fontWeight: 700,
                                    marginBottom: 10,
                                    color:
                                    s.accent === "green"
                                        ? "#2ecc71"
                                        : s.accent === "red"
                                        ? "#e74c3c"
                                        : "#3498db",
                                    textTransform: "uppercase",
                                    letterSpacing: 0.5,
                                }}
                                >
                                {d.title}
                                </h3>
                                <p style={{ color: "#cccccc", marginBottom: 12 }}>
                                {d.description}
                                </p>
                                <ul style={{ color: "#cccccc", paddingLeft: 18, marginBottom: 14 }}>
                                {d.features.map((f) => (
                                    <li key={f} style={{ marginBottom: 6 }}>
                                    {f}
                                    </li>
                                ))}
                                </ul>
                                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                                {d.tags.map((t) => (
                                    <span
                                    key={t}
                                    style={{
                                        background: "rgba(52,152,219,.1)",
                                        color: "#3498db",
                                        padding: "6px 10px",
                                        borderRadius: 6,
                                        fontSize: 12,
                                        letterSpacing: 0.3,
                                        textTransform: "uppercase",
                                    }}
                                    >
                                    {t}
                                    </span>
                                ))}
                                </div>
                            </article>
                            ))}
                        </div>
                        </div>
                    </div>
                    </section>
                ))}

                <section className={style["container--portfolio"]}>
                    <div className={style["unit--content"]}>
                    <h4 className={style["text--content"]}>Integrated Synergy</h4>
                    <p
                        className={style["text--content--copy"]}
                        style={{ width: "min(1000px, 100%)" }}
                    >
                        3개 솔루션의 유기적 결합으로 완전한 엔지니어링 생태계를 구현하여 고객 가치와 성공률을 극대화합니다.
                    </p>

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(2, auto)",
                            gridTemplateRows: "repeat(2, auto)",
                            gap: 20,
                            marginTop: 30,
                        }}
                    >
                        {SYNERGY.map((s) => (
                        <article
                            key={s.title}
                            style={{
                            background: "rgba(255,255,255,.05)",
                            border: "1px solid rgba(255,255,255,.12)",
                            borderRadius: 12,
                            padding: "24px 20px",
                            }}
                        >
                            <div style={{ fontWeight: 700, marginBottom: 8, color:"#ffffff" }}>{s.title}</div>
                            <div style={{ color: "#cccccc", fontSize: 14 }}>{s.description}</div>
                        </article>
                        ))}
                    </div>
                    </div>
                </section>

                {/* CTA */}
                <section className={style["container--portfolio"]}>
                    <div className={style["unit--content"]}>
                    <div
                        style={{
                        background: "linear-gradient(145deg,#1e1e1e,#2a2a2a)",
                        borderRadius: 12,
                        border: "1px solid #333",
                        padding: "40px 24px",
                        textAlign: "center",
                        }}
                    >
                        <h3 className={style["text--content"]} style={{ marginBottom: 10 }}>
                        Ready to Transform
                        </h3>
                        <p
                        className={style["text--content--copy"]}
                        style={{ width: "min(700px, 100%)" }}
                        >
                        3대 통합 솔루션으로 귀하의 엔지니어링 프로젝트를 새로운 차원으로 끌어올려보세요.
                        </p>
                        <div style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap", marginTop: 18 }}>
                        <a href="#" className={style["button--about"]}
                            onClick={(e) => {
                                e.preventDefault();
                                window.dispatchEvent(new CustomEvent("inbound:open"));
                            }}
                        >
                            솔루션 문의하기
                        </a>
                        </div>
                    </div>
                    </div>
                </section>
            </div>
        <Footer />
    </>
  );
}
